// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AddUpcomingInterestData, AddUpcomingInterestResponses, AutofillAgendaData, AutofillAgendaResponses, CompleteActionItemData, CompleteActionItemResponses, CompleteCalendarEventData, CompleteCalendarEventResponses, CompleteGoogleLoginData, CompleteOnboardingData, CompleteOnboardingErrors, CompleteOnboardingResponses, ConfirmActiveLabLogDraftData, ConfirmActiveLabLogDraftResponses, ConfirmAgendaItemData, ConfirmAgendaItemResponses, ConfirmReviewDocumentData, ConfirmReviewDocumentResponses, ConfirmStructuringData, ConfirmStructuringResponses, CreateAgendaItemData, CreateAgendaItemResponses, CreateAnalysisData, CreateAnalysisResponses, CreateCalendarEventData, CreateCalendarEventResponses, CreateGrantData, CreateGrantResponses, CreateGroupCreationRequestData, CreateGroupCreationRequestResponses, CreateGuestGrantData, CreateGuestGrantResponses, CreateHighlightData, CreateHighlightErrors, CreateHighlightResponses, CreateMeetingData, CreateMeetingResponses, CreateOnboardingUploadData, CreateOnboardingUploadResponses, DecideGroupCreationRequestData, DecideGroupCreationRequestResponses, DeleteActionItemData, DeleteActionItemResponses, DeleteActiveLabLogDraftData, DeleteActiveLabLogDraftResponses, DeleteCalendarEventData, DeleteCalendarEventResponses, DeleteHighlightData, DeleteHighlightResponses, DeleteReadingListItemData, DeleteReadingListItemResponses, DeleteResearchEventData, DeleteResearchEventResponses, DropActionItemData, DropActionItemResponses, ExchangeExtensionTokenData, ExchangeExtensionTokenErrors, ExchangeExtensionTokenResponses, ExcludeReviewDocumentData, ExcludeReviewDocumentResponses, ExportUpcomingCalendarData, ExportUpcomingCalendarResponses, ExtractMeetingActionItemsData, ExtractMeetingActionItemsResponses, GenerateMinutesData, GenerateMinutesResponses, GetActiveLabLogDraftData, GetActiveLabLogDraftResponses, GetAnalysisData, GetAnalysisResponses, GetBlockerData, GetBlockerResponses, GetDailyPickData, GetDailyPickResponses, GetGroupCreationRequestData, GetGroupCreationRequestDetailData, GetGroupCreationRequestDetailResponses, GetGroupCreationRequestResponses, GetHealthData, GetHealthResponses, GetHighlightCitationData, GetHighlightCitationResponses, GetHighlightData, GetHighlightResponses, GetInterestDraftData, GetInterestDraftResponses, GetInterestProfileData, GetInterestProfileResponses, GetLabDetailData, GetLabDetailResponses, GetLastActivityData, GetLastActivityResponses, GetMeData, GetMeErrors, GetMeetingData, GetMeetingResponses, GetMeResponses, GetMoreForYouData, GetMoreForYouResponses, GetOnboardingSessionData, GetOnboardingSessionResponses, GetPaperData, GetPaperResponses, GetUpcomingEventData, GetUpcomingEventResponses, HideCalendarEventData, HideCalendarEventResponses, LinkHighlightPaperData, LinkHighlightPaperResponses, ListAgendaItemsData, ListAgendaItemsResponses, ListCalendarItemsData, ListCalendarItemsResponses, ListConsentsData, ListConsentsResponses, ListGroupCreationRequestQueueData, ListGroupCreationRequestQueueResponses, ListGroupCreationRequestsData, ListGroupCreationRequestsResponses, ListHighlightsData, ListHighlightsResponses, ListKeywordsData, ListKeywordsResponses, ListMeetingActionItemsData, ListMeetingActionItemsResponses, ListMeetingsData, ListMeetingsResponses, ListMyLabsData, ListMyLabsResponses, ListPapersData, ListPapersResponses, ListReadingListItemsData, ListReadingListItemsResponses, ListResearchEventsData, ListResearchEventsResponses, ListReviewDocumentsData, ListReviewDocumentsResponses, ListRevisionsData, ListRevisionsResponses, ListSubfieldsData, ListSubfieldsResponses, ListTopicsData, ListTopicsResponses, ListUpcomingEventsData, ListUpcomingEventsResponses, LogoutData, LogoutExtensionData, LogoutExtensionResponses, LogoutResponses, MarkActionItemPaperWrongData, MarkActionItemPaperWrongResponses, PatchReviewDocumentData, PatchReviewDocumentResponses, PutInterestDraftData, PutInterestDraftResponses, QueuePendingData, QueuePendingResponses, ReadGuestResourceData, ReadGuestResourceResponses, RecheckHighlightData, RecheckHighlightErrors, RecheckHighlightResponses, RemoveUpcomingInterestData, RemoveUpcomingInterestResponses, ReopenActionItemData, ReopenActionItemResponses, RestoreReviewDocumentData, RestoreReviewDocumentResponses, RevokeGrantData, RevokeGrantResponses, RevokeGuestGrantData, RevokeGuestGrantResponses, SaveActiveLabLogDraftData, SaveActiveLabLogDraftResponses, SaveRecommendationToReadingListData, SaveRecommendationToReadingListResponses, SaveResearchEventsData, SaveResearchEventsResponses, SaveRevisionData, SaveRevisionResponses, ShareMeetingData, ShareMeetingResponses, StartExtensionLoginData, StartExtensionLoginErrors, StartGoogleLoginData, SubmitConsentsData, SubmitConsentsResponses, UnconfirmReviewDocumentData, UnconfirmReviewDocumentResponses, UnhideCalendarEventData, UnhideCalendarEventResponses, UpdateActionItemData, UpdateActionItemResponses, UpdateCalendarEventData, UpdateCalendarEventResponses, UpdateGrantData, UpdateGrantResponses, UpdateHighlightData, UpdateHighlightResponses, UpdateInterestProfileData, UpdateInterestProfileErrors, UpdateInterestProfileResponses, UpdateMeetingData, UpdateMeetingResponses, UpdateMinutesData, UpdateMinutesResponses, UpdateReadingListItemData, UpdateReadingListItemResponses, UpdateResearchEventData, UpdateResearchEventResponses, WrapUpMeetingData, WrapUpMeetingResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Google 로그인 시작
 *
 * Google 인가 화면으로 302한다. `state`와 PKCE 검증값을 서버에 저장한다.
 */
export const startGoogleLogin = <ThrowOnError extends boolean = false>(options?: Options<StartGoogleLoginData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/v1/auth/google', ...options });

/**
 * Google 로그인 callback
 */
export const completeGoogleLogin = <ThrowOnError extends boolean = false>(options?: Options<CompleteGoogleLoginData, ThrowOnError>): RequestResult<unknown, unknown, ThrowOnError> => (options?.client ?? client).get<unknown, unknown, ThrowOnError>({ url: '/v1/auth/google/callback', ...options });

/**
 * 로그아웃 — 세션 회수와 쿠키 삭제
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, unknown, ThrowOnError>({ url: '/v1/auth/logout', ...options });

/**
 * 내 계정 · 기관 소속 · 그룹 membership
 */
export const getMe = <ThrowOnError extends boolean = false>(options?: Options<GetMeData, ThrowOnError>): RequestResult<GetMeResponses, GetMeErrors, ThrowOnError> => (options?.client ?? client).get<GetMeResponses, GetMeErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/me',
    ...options
});

/**
 * 확장 로그인 시작
 *
 * 확장이 직접 연 로그인 창이 연다. 허용된 확장과 완료 페이지 redirect URI만 Google 인가로 302한다.
 */
export const startExtensionLogin = <ThrowOnError extends boolean = false>(options: Options<StartExtensionLoginData, ThrowOnError>): RequestResult<unknown, StartExtensionLoginErrors, ThrowOnError> => (options.client ?? client).get<unknown, StartExtensionLoginErrors, ThrowOnError>({ url: '/v1/auth/extension/start', ...options });

/**
 * 확장 토큰 — 한 번 코드 교환 · 갱신
 *
 * `DPoP` 증명 헤더가 필요하다. 응답은 `Cache-Control: no-store`다.
 */
export const exchangeExtensionToken = <ThrowOnError extends boolean = false>(options: Options<ExchangeExtensionTokenData, ThrowOnError>): RequestResult<ExchangeExtensionTokenResponses, ExchangeExtensionTokenErrors, ThrowOnError> => (options.client ?? client).post<ExchangeExtensionTokenResponses, ExchangeExtensionTokenErrors, ThrowOnError>({
    url: '/v1/auth/extension/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 확장 로그아웃 — 갱신 토큰의 가족 회수
 *
 * 증명 키가 가족의 키와 같을 때만 회수한다. 무엇이 와도 `204`다.
 */
export const logoutExtension = <ThrowOnError extends boolean = false>(options: Options<LogoutExtensionData, ThrowOnError>): RequestResult<LogoutExtensionResponses, unknown, ThrowOnError> => (options.client ?? client).post<LogoutExtensionResponses, unknown, ThrowOnError>({
    url: '/v1/auth/extension/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 내 Lab 생성 신청 목록
 */
export const listGroupCreationRequests = <ThrowOnError extends boolean = false>(options?: Options<ListGroupCreationRequestsData, ThrowOnError>): RequestResult<ListGroupCreationRequestsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListGroupCreationRequestsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/group-creation-requests',
    ...options
});

/**
 * 최초 Lab 생성 신청
 */
export const createGroupCreationRequest = <ThrowOnError extends boolean = false>(options: Options<CreateGroupCreationRequestData, ThrowOnError>): RequestResult<CreateGroupCreationRequestResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateGroupCreationRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/group-creation-requests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 내 Lab 생성 신청 상세
 */
export const getGroupCreationRequest = <ThrowOnError extends boolean = false>(options: Options<GetGroupCreationRequestData, ThrowOnError>): RequestResult<GetGroupCreationRequestResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetGroupCreationRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/group-creation-requests/{id}',
    ...options
});

/**
 * Lab 생성 신청 대기열 (운영자 전용)
 */
export const listGroupCreationRequestQueue = <ThrowOnError extends boolean = false>(options?: Options<ListGroupCreationRequestQueueData, ThrowOnError>): RequestResult<ListGroupCreationRequestQueueResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListGroupCreationRequestQueueResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/admin/group-creation-requests',
    ...options
});

/**
 * Lab 생성 신청 상세 (운영자 전용)
 */
export const getGroupCreationRequestDetail = <ThrowOnError extends boolean = false>(options: Options<GetGroupCreationRequestDetailData, ThrowOnError>): RequestResult<GetGroupCreationRequestDetailResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetGroupCreationRequestDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/admin/group-creation-requests/{id}',
    ...options
});

/**
 * Lab 생성 신청 승인·거절 (운영자 전용)
 */
export const decideGroupCreationRequest = <ThrowOnError extends boolean = false>(options: Options<DecideGroupCreationRequestData, ThrowOnError>): RequestResult<DecideGroupCreationRequestResponses, unknown, ThrowOnError> => (options.client ?? client).post<DecideGroupCreationRequestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/admin/group-creation-requests/{id}/decisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 서비스 상태 및 서버 기준 시각
 *
 * compose healthcheck와 운영 점검이 사용한다.
 */
export const getHealth = <ThrowOnError extends boolean = false>(options?: Options<GetHealthData, ThrowOnError>): RequestResult<GetHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetHealthResponses, unknown, ThrowOnError>({ url: '/v1/health', ...options });

/**
 * 현행 동의 문서와 내 동의 상태
 */
export const listConsents = <ThrowOnError extends boolean = false>(options?: Options<ListConsentsData, ThrowOnError>): RequestResult<ListConsentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConsentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/consents',
    ...options
});

/**
 * 항목별 동의·철회를 한 번에 제출
 */
export const submitConsents = <ThrowOnError extends boolean = false>(options: Options<SubmitConsentsData, ThrowOnError>): RequestResult<SubmitConsentsResponses, unknown, ThrowOnError> => (options.client ?? client).put<SubmitConsentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/consents',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 온보딩 자료 업로드 (파일 1개)
 */
export const createOnboardingUpload = <ThrowOnError extends boolean = false>(options: Options<CreateOnboardingUploadData, ThrowOnError>): RequestResult<CreateOnboardingUploadResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateOnboardingUploadResponses, unknown, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/uploads',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * 온보딩 진행 상태
 */
export const getOnboardingSession = <ThrowOnError extends boolean = false>(options?: Options<GetOnboardingSessionData, ThrowOnError>): RequestResult<GetOnboardingSessionResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOnboardingSessionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/session',
    ...options
});

/**
 * 온보딩 문서 분석 시작 (멱등) — E16 §7
 */
export const createAnalysis = <ThrowOnError extends boolean = false>(options?: Options<CreateAnalysisData, ThrowOnError>): RequestResult<CreateAnalysisResponses, unknown, ThrowOnError> => (options?.client ?? client).post<CreateAnalysisResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/analysis',
    ...options
});

/**
 * 온보딩 문서 분석 상태 조회 — E16 §7
 */
export const getAnalysis = <ThrowOnError extends boolean = false>(options: Options<GetAnalysisData, ThrowOnError>): RequestResult<GetAnalysisResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetAnalysisResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/analysis/{jobId}',
    ...options
});

/**
 * 검토 문서 목록
 */
export const listReviewDocuments = <ThrowOnError extends boolean = false>(options?: Options<ListReviewDocumentsData, ThrowOnError>): RequestResult<ListReviewDocumentsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListReviewDocumentsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents',
    ...options
});

/**
 * 검토 문서의 수정 가능 필드 저장
 */
export const patchReviewDocument = <ThrowOnError extends boolean = false>(options: Options<PatchReviewDocumentData, ThrowOnError>): RequestResult<PatchReviewDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).patch<PatchReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 검토 문서 확인 해제
 */
export const unconfirmReviewDocument = <ThrowOnError extends boolean = false>(options: Options<UnconfirmReviewDocumentData, ThrowOnError>): RequestResult<UnconfirmReviewDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UnconfirmReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents/{id}/confirm',
    ...options
});

/**
 * 검토 문서 확인
 */
export const confirmReviewDocument = <ThrowOnError extends boolean = false>(options: Options<ConfirmReviewDocumentData, ThrowOnError>): RequestResult<ConfirmReviewDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfirmReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents/{id}/confirm',
    ...options
});

/**
 * 검토 문서 제외 복구
 */
export const restoreReviewDocument = <ThrowOnError extends boolean = false>(options: Options<RestoreReviewDocumentData, ThrowOnError>): RequestResult<RestoreReviewDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RestoreReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents/{id}/exclude',
    ...options
});

/**
 * 검토 문서 제외
 */
export const excludeReviewDocument = <ThrowOnError extends boolean = false>(options: Options<ExcludeReviewDocumentData, ThrowOnError>): RequestResult<ExcludeReviewDocumentResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExcludeReviewDocumentResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/documents/{id}/exclude',
    ...options
});

/**
 * 온보딩 성과·관심 프로필 원자적 확정
 */
export const completeOnboarding = <ThrowOnError extends boolean = false>(options?: Options<CompleteOnboardingData, ThrowOnError>): RequestResult<CompleteOnboardingResponses, CompleteOnboardingErrors, ThrowOnError> => (options?.client ?? client).post<CompleteOnboardingResponses, CompleteOnboardingErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/complete',
    ...options
});

/**
 * 온보딩 관심 연구 분야 초안 조회
 */
export const getInterestDraft = <ThrowOnError extends boolean = false>(options?: Options<GetInterestDraftData, ThrowOnError>): RequestResult<GetInterestDraftResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInterestDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/interest-draft',
    ...options
});

/**
 * 온보딩 관심 연구 분야 초안 저장
 */
export const putInterestDraft = <ThrowOnError extends boolean = false>(options: Options<PutInterestDraftData, ThrowOnError>): RequestResult<PutInterestDraftResponses, unknown, ThrowOnError> => (options.client ?? client).put<PutInterestDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/onboarding/interest-draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * 현재 관심 연구 분야 조회
 */
export const getInterestProfile = <ThrowOnError extends boolean = false>(options?: Options<GetInterestProfileData, ThrowOnError>): RequestResult<GetInterestProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetInterestProfileResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/profile/interests',
    ...options
});

/**
 * 관심 연구 분야 확정
 */
export const updateInterestProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateInterestProfileData, ThrowOnError>): RequestResult<UpdateInterestProfileResponses, UpdateInterestProfileErrors, ThrowOnError> => (options.client ?? client).put<UpdateInterestProfileResponses, UpdateInterestProfileErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/profile/interests',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listSubfields = <ThrowOnError extends boolean = false>(options?: Options<ListSubfieldsData, ThrowOnError>): RequestResult<ListSubfieldsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListSubfieldsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/concepts/subfields',
    ...options
});

export const listTopics = <ThrowOnError extends boolean = false>(options?: Options<ListTopicsData, ThrowOnError>): RequestResult<ListTopicsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListTopicsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/concepts/topics',
    ...options
});

export const listKeywords = <ThrowOnError extends boolean = false>(options?: Options<ListKeywordsData, ThrowOnError>): RequestResult<ListKeywordsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListKeywordsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/concepts/keywords',
    ...options
});

export const queuePending = <ThrowOnError extends boolean = false>(options: Options<QueuePendingData, ThrowOnError>): RequestResult<QueuePendingResponses, unknown, ThrowOnError> => (options.client ?? client).post<QueuePendingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/concepts/pending',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getLastActivity = <ThrowOnError extends boolean = false>(options?: Options<GetLastActivityData, ThrowOnError>): RequestResult<GetLastActivityResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLastActivityResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/last-activity',
    ...options
});

export const listResearchEvents = <ThrowOnError extends boolean = false>(options?: Options<ListResearchEventsData, ThrowOnError>): RequestResult<ListResearchEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListResearchEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-events',
    ...options
});

export const saveResearchEvents = <ThrowOnError extends boolean = false>(options: Options<SaveResearchEventsData, ThrowOnError>): RequestResult<SaveResearchEventsResponses, unknown, ThrowOnError> => (options.client ?? client).post<SaveResearchEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteResearchEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteResearchEventData, ThrowOnError>): RequestResult<DeleteResearchEventResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteResearchEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-events/{id}',
    ...options
});

export const updateResearchEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateResearchEventData, ThrowOnError>): RequestResult<UpdateResearchEventResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateResearchEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-events/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteActiveLabLogDraft = <ThrowOnError extends boolean = false>(options?: Options<DeleteActiveLabLogDraftData, ThrowOnError>): RequestResult<DeleteActiveLabLogDraftResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<DeleteActiveLabLogDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-event-drafts/active',
    ...options
});

export const getActiveLabLogDraft = <ThrowOnError extends boolean = false>(options?: Options<GetActiveLabLogDraftData, ThrowOnError>): RequestResult<GetActiveLabLogDraftResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetActiveLabLogDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-event-drafts/active',
    ...options
});

export const saveActiveLabLogDraft = <ThrowOnError extends boolean = false>(options: Options<SaveActiveLabLogDraftData, ThrowOnError>): RequestResult<SaveActiveLabLogDraftResponses, unknown, ThrowOnError> => (options.client ?? client).put<SaveActiveLabLogDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-event-drafts/active',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const confirmActiveLabLogDraft = <ThrowOnError extends boolean = false>(options?: Options<ConfirmActiveLabLogDraftData, ThrowOnError>): RequestResult<ConfirmActiveLabLogDraftResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ConfirmActiveLabLogDraftResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/research-event-drafts/active/confirm',
    ...options
});

export const getBlocker = <ThrowOnError extends boolean = false>(options: Options<GetBlockerData, ThrowOnError>): RequestResult<GetBlockerResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetBlockerResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/blockers',
    ...options
});

export const confirmStructuring = <ThrowOnError extends boolean = false>(options: Options<ConfirmStructuringData, ThrowOnError>): RequestResult<ConfirmStructuringResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfirmStructuringResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/blockers/{id}/structuring/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMeetings = <ThrowOnError extends boolean = false>(options?: Options<ListMeetingsData, ThrowOnError>): RequestResult<ListMeetingsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMeetingsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings',
    ...options
});

export const createMeeting = <ThrowOnError extends boolean = false>(options: Options<CreateMeetingData, ThrowOnError>): RequestResult<CreateMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateMeetingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getMeeting = <ThrowOnError extends boolean = false>(options: Options<GetMeetingData, ThrowOnError>): RequestResult<GetMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetMeetingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}',
    ...options
});

export const updateMeeting = <ThrowOnError extends boolean = false>(options: Options<UpdateMeetingData, ThrowOnError>): RequestResult<UpdateMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateMeetingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const shareMeeting = <ThrowOnError extends boolean = false>(options: Options<ShareMeetingData, ThrowOnError>): RequestResult<ShareMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).post<ShareMeetingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/share',
    ...options
});

export const listAgendaItems = <ThrowOnError extends boolean = false>(options: Options<ListAgendaItemsData, ThrowOnError>): RequestResult<ListAgendaItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListAgendaItemsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/agenda-items',
    ...options
});

export const createAgendaItem = <ThrowOnError extends boolean = false>(options: Options<CreateAgendaItemData, ThrowOnError>): RequestResult<CreateAgendaItemResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateAgendaItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/agenda-items',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const autofillAgenda = <ThrowOnError extends boolean = false>(options: Options<AutofillAgendaData, ThrowOnError>): RequestResult<AutofillAgendaResponses, unknown, ThrowOnError> => (options.client ?? client).post<AutofillAgendaResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/agenda-items/autofill',
    ...options
});

export const updateMinutes = <ThrowOnError extends boolean = false>(options: Options<UpdateMinutesData, ThrowOnError>): RequestResult<UpdateMinutesResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateMinutesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/minutes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const generateMinutes = <ThrowOnError extends boolean = false>(options: Options<GenerateMinutesData, ThrowOnError>): RequestResult<GenerateMinutesResponses, unknown, ThrowOnError> => (options.client ?? client).post<GenerateMinutesResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/minutes',
    ...options
});

export const wrapUpMeeting = <ThrowOnError extends boolean = false>(options: Options<WrapUpMeetingData, ThrowOnError>): RequestResult<WrapUpMeetingResponses, unknown, ThrowOnError> => (options.client ?? client).post<WrapUpMeetingResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/wrap-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const extractMeetingActionItems = <ThrowOnError extends boolean = false>(options: Options<ExtractMeetingActionItemsData, ThrowOnError>): RequestResult<ExtractMeetingActionItemsResponses, unknown, ThrowOnError> => (options.client ?? client).post<ExtractMeetingActionItemsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/action-items/extract',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMeetingActionItems = <ThrowOnError extends boolean = false>(options: Options<ListMeetingActionItemsData, ThrowOnError>): RequestResult<ListMeetingActionItemsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListMeetingActionItemsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/meetings/{id}/action-items',
    ...options
});

export const confirmAgendaItem = <ThrowOnError extends boolean = false>(options: Options<ConfirmAgendaItemData, ThrowOnError>): RequestResult<ConfirmAgendaItemResponses, unknown, ThrowOnError> => (options.client ?? client).post<ConfirmAgendaItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/agenda-items/{id}/confirm',
    ...options
});

export const deleteActionItem = <ThrowOnError extends boolean = false>(options: Options<DeleteActionItemData, ThrowOnError>): RequestResult<DeleteActionItemResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteActionItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}',
    ...options
});

export const updateActionItem = <ThrowOnError extends boolean = false>(options: Options<UpdateActionItemData, ThrowOnError>): RequestResult<UpdateActionItemResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateActionItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markActionItemPaperWrong = <ThrowOnError extends boolean = false>(options: Options<MarkActionItemPaperWrongData, ThrowOnError>): RequestResult<MarkActionItemPaperWrongResponses, unknown, ThrowOnError> => (options.client ?? client).post<MarkActionItemPaperWrongResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}/paper-wrong',
    ...options
});

export const completeActionItem = <ThrowOnError extends boolean = false>(options: Options<CompleteActionItemData, ThrowOnError>): RequestResult<CompleteActionItemResponses, unknown, ThrowOnError> => (options.client ?? client).post<CompleteActionItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}/complete',
    ...options
});

export const dropActionItem = <ThrowOnError extends boolean = false>(options: Options<DropActionItemData, ThrowOnError>): RequestResult<DropActionItemResponses, unknown, ThrowOnError> => (options.client ?? client).post<DropActionItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}/drop',
    ...options
});

export const reopenActionItem = <ThrowOnError extends boolean = false>(options: Options<ReopenActionItemData, ThrowOnError>): RequestResult<ReopenActionItemResponses, unknown, ThrowOnError> => (options.client ?? client).post<ReopenActionItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/action-items/{id}/reopen',
    ...options
});

export const listCalendarItems = <ThrowOnError extends boolean = false>(options?: Options<ListCalendarItemsData, ThrowOnError>): RequestResult<ListCalendarItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListCalendarItemsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar',
    ...options
});

export const createCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<CreateCalendarEventData, ThrowOnError>): RequestResult<CreateCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<DeleteCalendarEventData, ThrowOnError>): RequestResult<DeleteCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events/{id}',
    ...options
});

export const updateCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<UpdateCalendarEventData, ThrowOnError>): RequestResult<UpdateCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const completeCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<CompleteCalendarEventData, ThrowOnError>): RequestResult<CompleteCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<CompleteCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events/{id}/complete',
    ...options
});

export const unhideCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<UnhideCalendarEventData, ThrowOnError>): RequestResult<UnhideCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).delete<UnhideCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events/{id}/hide',
    ...options
});

export const hideCalendarEvent = <ThrowOnError extends boolean = false>(options: Options<HideCalendarEventData, ThrowOnError>): RequestResult<HideCalendarEventResponses, unknown, ThrowOnError> => (options.client ?? client).post<HideCalendarEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/calendar/events/{id}/hide',
    ...options
});

export const listMyLabs = <ThrowOnError extends boolean = false>(options?: Options<ListMyLabsData, ThrowOnError>): RequestResult<ListMyLabsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListMyLabsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/me/labs',
    ...options
});

export const getLabDetail = <ThrowOnError extends boolean = false>(options: Options<GetLabDetailData, ThrowOnError>): RequestResult<GetLabDetailResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetLabDetailResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/labs/{groupId}',
    ...options
});

export const createGrant = <ThrowOnError extends boolean = false>(options: Options<CreateGrantData, ThrowOnError>): RequestResult<CreateGrantResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateGrantResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resources/{resourceType}/{resourceId}/grants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeGrant = <ThrowOnError extends boolean = false>(options: Options<RevokeGrantData, ThrowOnError>): RequestResult<RevokeGrantResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RevokeGrantResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resource-grants/{grantId}',
    ...options
});

export const updateGrant = <ThrowOnError extends boolean = false>(options: Options<UpdateGrantData, ThrowOnError>): RequestResult<UpdateGrantResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateGrantResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resource-grants/{grantId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listRevisions = <ThrowOnError extends boolean = false>(options: Options<ListRevisionsData, ThrowOnError>): RequestResult<ListRevisionsResponses, unknown, ThrowOnError> => (options.client ?? client).get<ListRevisionsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resources/{resourceType}/{resourceId}/revisions',
    ...options
});

export const saveRevision = <ThrowOnError extends boolean = false>(options: Options<SaveRevisionData, ThrowOnError>): RequestResult<SaveRevisionResponses, unknown, ThrowOnError> => (options.client ?? client).post<SaveRevisionResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resources/{resourceType}/{resourceId}/revisions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createGuestGrant = <ThrowOnError extends boolean = false>(options: Options<CreateGuestGrantData, ThrowOnError>): RequestResult<CreateGuestGrantResponses, unknown, ThrowOnError> => (options.client ?? client).post<CreateGuestGrantResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/resources/{resourceType}/{resourceId}/guest-grants',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const revokeGuestGrant = <ThrowOnError extends boolean = false>(options: Options<RevokeGuestGrantData, ThrowOnError>): RequestResult<RevokeGuestGrantResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RevokeGuestGrantResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/guest-grants/{grantId}',
    ...options
});

export const readGuestResource = <ThrowOnError extends boolean = false>(options: Options<ReadGuestResourceData, ThrowOnError>): RequestResult<ReadGuestResourceResponses, unknown, ThrowOnError> => (options.client ?? client).get<ReadGuestResourceResponses, unknown, ThrowOnError>({ url: '/v1/guest/{token}', ...options });

export const getDailyPick = <ThrowOnError extends boolean = false>(options?: Options<GetDailyPickData, ThrowOnError>): RequestResult<GetDailyPickResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDailyPickResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/recommendations/daily-pick',
    ...options
});

export const getMoreForYou = <ThrowOnError extends boolean = false>(options?: Options<GetMoreForYouData, ThrowOnError>): RequestResult<GetMoreForYouResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMoreForYouResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/recommendations/more-for-you',
    ...options
});

export const listReadingListItems = <ThrowOnError extends boolean = false>(options?: Options<ListReadingListItemsData, ThrowOnError>): RequestResult<ListReadingListItemsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListReadingListItemsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/reading-list',
    ...options
});

export const deleteReadingListItem = <ThrowOnError extends boolean = false>(options: Options<DeleteReadingListItemData, ThrowOnError>): RequestResult<DeleteReadingListItemResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteReadingListItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/reading-list/{paper_id}',
    ...options
});

export const updateReadingListItem = <ThrowOnError extends boolean = false>(options: Options<UpdateReadingListItemData, ThrowOnError>): RequestResult<UpdateReadingListItemResponses, unknown, ThrowOnError> => (options.client ?? client).put<UpdateReadingListItemResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/reading-list/{paper_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const saveRecommendationToReadingList = <ThrowOnError extends boolean = false>(options: Options<SaveRecommendationToReadingListData, ThrowOnError>): RequestResult<SaveRecommendationToReadingListResponses, unknown, ThrowOnError> => (options.client ?? client).put<SaveRecommendationToReadingListResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/recommendations/{recommendation_id}/reading-list',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listPapers = <ThrowOnError extends boolean = false>(options?: Options<ListPapersData, ThrowOnError>): RequestResult<ListPapersResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListPapersResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/papers',
    ...options
});

export const getPaper = <ThrowOnError extends boolean = false>(options: Options<GetPaperData, ThrowOnError>): RequestResult<GetPaperResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetPaperResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/papers/{id}',
    ...options
});

export const listHighlights = <ThrowOnError extends boolean = false>(options?: Options<ListHighlightsData, ThrowOnError>): RequestResult<ListHighlightsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListHighlightsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights',
    ...options
});

export const createHighlight = <ThrowOnError extends boolean = false>(options: Options<CreateHighlightData, ThrowOnError>): RequestResult<CreateHighlightResponses, CreateHighlightErrors, ThrowOnError> => (options.client ?? client).post<CreateHighlightResponses, CreateHighlightErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deleteHighlight = <ThrowOnError extends boolean = false>(options: Options<DeleteHighlightData, ThrowOnError>): RequestResult<DeleteHighlightResponses, unknown, ThrowOnError> => (options.client ?? client).delete<DeleteHighlightResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}',
    ...options
});

export const getHighlight = <ThrowOnError extends boolean = false>(options: Options<GetHighlightData, ThrowOnError>): RequestResult<GetHighlightResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetHighlightResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}',
    ...options
});

export const updateHighlight = <ThrowOnError extends boolean = false>(options: Options<UpdateHighlightData, ThrowOnError>): RequestResult<UpdateHighlightResponses, unknown, ThrowOnError> => (options.client ?? client).patch<UpdateHighlightResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const linkHighlightPaper = <ThrowOnError extends boolean = false>(options: Options<LinkHighlightPaperData, ThrowOnError>): RequestResult<LinkHighlightPaperResponses, unknown, ThrowOnError> => (options.client ?? client).post<LinkHighlightPaperResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}/paper-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const recheckHighlight = <ThrowOnError extends boolean = false>(options: Options<RecheckHighlightData, ThrowOnError>): RequestResult<RecheckHighlightResponses, RecheckHighlightErrors, ThrowOnError> => (options.client ?? client).post<RecheckHighlightResponses, RecheckHighlightErrors, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}/recheck',
    ...options
});

export const getHighlightCitation = <ThrowOnError extends boolean = false>(options: Options<GetHighlightCitationData, ThrowOnError>): RequestResult<GetHighlightCitationResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetHighlightCitationResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/highlights/{id}/citation',
    ...options
});

export const listUpcomingEvents = <ThrowOnError extends boolean = false>(options?: Options<ListUpcomingEventsData, ThrowOnError>): RequestResult<ListUpcomingEventsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListUpcomingEventsResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/upcoming',
    ...options
});

export const getUpcomingEvent = <ThrowOnError extends boolean = false>(options: Options<GetUpcomingEventData, ThrowOnError>): RequestResult<GetUpcomingEventResponses, unknown, ThrowOnError> => (options.client ?? client).get<GetUpcomingEventResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/upcoming/{id}',
    ...options
});

export const exportUpcomingCalendar = <ThrowOnError extends boolean = false>(options: Options<ExportUpcomingCalendarData, ThrowOnError>): RequestResult<ExportUpcomingCalendarResponses, unknown, ThrowOnError> => (options.client ?? client).get<ExportUpcomingCalendarResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/upcoming/{id}/calendar-export',
    ...options
});

export const removeUpcomingInterest = <ThrowOnError extends boolean = false>(options: Options<RemoveUpcomingInterestData, ThrowOnError>): RequestResult<RemoveUpcomingInterestResponses, unknown, ThrowOnError> => (options.client ?? client).delete<RemoveUpcomingInterestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/upcoming/{id}/interest',
    ...options
});

export const addUpcomingInterest = <ThrowOnError extends boolean = false>(options: Options<AddUpcomingInterestData, ThrowOnError>): RequestResult<AddUpcomingInterestResponses, unknown, ThrowOnError> => (options.client ?? client).put<AddUpcomingInterestResponses, unknown, ThrowOnError>({
    security: [{
            in: 'cookie',
            name: '__Host-labflow_session',
            type: 'apiKey'
        }],
    url: '/v1/upcoming/{id}/interest',
    ...options
});
